export class CustomError extends Error {
    public message: string;
    public restart: boolean;

    constructor(message: string, restart: boolean) {
        super();

        this.message = message;
        this.restart = restart;
    }
}
